import { createGlobalStyle } from 'styled-components';
import { getColor } from '../../../src/styled/utils';
export const DatePickerWrapperStyles = createGlobalStyle `
    .date-picker.full-width {
        width: 100%;
    }
    
    .date-picker.clear-button::after {
      padding: 0;
      color: ${getColor('onSurface')};
      font-weight: bold;
      background-color: transparent;
      border: 1px solid;
    }
    
`;
